// Basic or advanced view of the console (ux-simplify §3.1, Б2), one answer for
// the whole shell: the menu lists engineering screens only in the advanced
// view, and the summary under the header drops the engineer's figures
// ("Подачи", SRT loss, agents) in the basic one (P1-10). The stored choice
// wins; without one the role decides (it may arrive after mount - computed).

import { defineStore } from 'pinia'
import { computed, shallowRef } from 'vue'
import { defaultView, setStoredView, storedView, type ConsoleView } from '@/features/simple/model/mode'
import { useSessionStore } from './session'

export const useViewStore = defineStore('console-view', () => {
  const session = useSessionStore()
  const chosen = shallowRef<ConsoleView | null>(storedView())
  const view = computed<ConsoleView>(() => chosen.value ?? defaultView(session.role))
  const advanced = computed(() => view.value === 'advanced')

  /** Switches the view; the choice is remembered in this browser when storage allows (otherwise for this page only). */
  function setAdvanced(on: boolean): void {
    const next: ConsoleView = on ? 'advanced' : 'basic'
    chosen.value = next
    setStoredView(next)
  }

  return { view, advanced, setAdvanced }
})
